module.exports = __webpack_public_path__ + "icon_ok.076cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_ok.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_ok.svg
// module chunks = main